global.gstList = global.API_ADMIN_URL+'gstList/';
global.adminAddGst = global.API_ADMIN_URL+'adminAddGst/';
global.adminEditGst = global.API_ADMIN_URL+'adminEditGst/';
global.gstDetails = global.API_ADMIN_URL+'gstDetails/';
global.adminTaxStatus = global.API_ADMIN_URL+'adminTaxStatus/';